import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Globe } from 'lucide-react';

const QUICK_LINKS = [
  { to: '/artists', label: 'Artists' },
  { to: '/element45', label: 'Element 45' },
  { to: '/store', label: 'Store' }
];

const FooterBrand = () => (
  <div className="col-span-1 md:col-span-2">
    <div className="flex items-center gap-4 mb-6">
      <img src="/rhodium-logo.png" alt="Rhodium Records" className="logo-img h-16 w-16 object-contain" />
      <h3 className="logo-text text-3xl font-black">RHODIUM RECORDS</h3>
    </div>
    <p className="text-white/60 text-sm leading-relaxed max-w-md mb-4">
      Rare by nature, relentless by design. Crafting music that cuts through the noise
      and lasts from Rhodium Records.
    </p>
    <a
      href="https://www.RhodiumRecords.music"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 text-silver-400 hover:text-silver-300 text-sm transition-colors"
    >
      <Globe size={16} />
      www.RhodiumRecords.music
    </a>
  </div>
);

const FooterQuickLinks = () => (
  <div>
    <h4 className="text-silver-400 font-semibold text-sm uppercase tracking-wider mb-4">Quick Links</h4>
    <ul className="space-y-2">
      {QUICK_LINKS.map(({ to, label }) => (
        <li key={to}>
          <Link to={to} className="text-white/60 hover:text-silver-400 text-sm transition-colors">
            {label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

const FooterContact = () => (
  <div>
    <h4 className="text-silver-400 font-semibold text-sm uppercase tracking-wider mb-4">Contact</h4>
    <ul className="space-y-2 text-sm">
      <li className="text-white/60">
        <a href="mailto:info@rhodiumrecords.music" className="hover:text-silver-400 transition-colors">
          info@rhodiumrecords.music
        </a>
      </li>
    </ul>
  </div>
);

const FooterBottom = () => (
  <div className="border-t border-silver-900/20 pt-8 flex flex-col md:flex-row items-center justify-between">
    <p className="text-white/40 text-sm mb-4 md:mb-0">
      © {new Date().getFullYear()} Rhodium Records. All rights reserved.
    </p>
    <div className="flex items-center gap-4">
      <a
        href="https://www.instagram.com/rhodiumrecordsmusic/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        className="text-white/60 hover:text-silver-400 transition-all duration-300 hover:scale-110 flex items-center gap-2"
      >
        <Instagram size={20} />
        <span className="text-sm">@RhodiumRecordsMusic</span>
      </a>
    </div>
  </div>
);

const Footer = () => (
  <footer className="bg-black border-t border-silver-900/20">
    <div className="container mx-auto px-6 py-12">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
        <FooterBrand />
        <FooterQuickLinks />
        <FooterContact />
      </div>
      <FooterBottom />
    </div>
  </footer>
);

export default Footer;
